import { FT, Spine } from 'ft'

const $SPINE_BG = 'spine.SC02_03'
const $soundDoorKnock = 'sound.door-knock'
const $soundDoorOpen = 'sound.door-open'

FT.rm.addSpine($SPINE_BG)
FT.rm.addSound($soundDoorKnock)
FT.rm.addSound($soundDoorOpen)

class Animation extends Spine {
  constructor() {
    super(FT.rm.spine($SPINE_BG))

    this.animations = {}

    this.stateData.setMix('SC02_Loop', 'SC03_Loop', 0.5)
    this.scale.set(0.5, 0.5)
    this.position.set(FT.stage.centerX, FT.stage.centerY)
    this.state.setAnimation(0, 'SC02_Loop', true)

    this.skeleton.setAttachment('SC02_03/Dongdong', null)
    this.animations.knock = this.state.setAnimation(1, 'SC02_Knock')
    this.animations.knock.timeScale = 0
  }

  knockDoor() {
    this.skeleton.setAttachment('SC02_03/Dongdong', 'SC02_03/Dongdong')
    this.animations.knock.timeScale = 1
    FT.rm.sound($soundDoorKnock).play()
  }

  hideKnockTip() {
    this.skeleton.setAttachment('SC02_03/Dongdong', null)
  }

  openDoor() {
    this.state.setAnimation(0, 'SC03_Loop', true)
    this.state.setAnimation(1, 'SC03_Snow_Loop', true)
    FT.rm.sound($soundDoorOpen).play()
  }
}

export default Animation
